/**
 * The maturity status of a feature
 */
export enum FeatureStatus {
  Beta = 'BETA',
  Alpha = 'ALPHA',
  GeneralAvailability = 'GENERAL_AVAILABILITY',
}

/**
 * The type of value a feature can have
 */
export enum FeatureType {
  Boolean = 'BOOLEAN',
  FeatureGate = 'FEATURE_GATE',
  Number = 'NUMBER',
  StringList = 'STRING_LIST',
  SupportTier = 'SUPPORT_TIER',
}

/**
 * Names of features in the database
 */
export enum FeatureDefinitionName {
  ActionItemChecklists = 'ACTION_ITEM_CHECKLISTS',
  AirgapAllowedVersionTags = 'AIRGAP_ALLOWED_VERSION_TAGS',
  AllowPrivateDockerRegistryAccess = 'ALLOW_PRIVATE_DOCKER_REGISTRY_ACCESS',
  Assessments = 'ASSESSMENTS',
  AuditorMonthlyUsageLimit = 'AUDITOR_MONTHLY_USAGE_LIMIT',
  ConsentWorkflows = 'CONSENT_WORKFLOWS',
  ContractScanning = 'CONTRACT_SCANNING',
  CustomDomainUI = 'CUSTOM_DOMAIN_UI',
  DataLineage = 'DATA_LINEAGE',
  DisabledPrivacyCenterAboutTranscend = 'DISABLED_PRIVACY_CENTER_ABOUT_TRANSCEND',
  DsrAutomation = 'DSR_AUTOMATION',
  IsSandbox = 'IS_SANDBOX',
  LlmClassifier = 'LLM_CLASSIFIER',
  LlmUnstructured = 'LLM_UNSTRUCTURED',
  MaxSyncDomainCount = 'MAX_SYNC_DOMAIN_COUNT',
  MobileConsentApps = 'MOBILE_CONSENT_APPS',
  Pathfinder = 'PATHFINDER',
  PreferenceStore = 'PREFERENCE_STORE',
  PrivacyCenter = 'PRIVACY_CENTER',
  Prompts = 'PROMPTS',
  SaleOfInfoToggle = 'SALE_OF_INFO_TOGGLE',
  SelfHostedSombra = 'SELF_HOSTED_SOMBRA',
  SiloDiscovery = 'SILO_DISCOVERY',
  StructuredDataDiscovery = 'STRUCTURED_DATA_DISCOVERY',
  SupportTier = 'SUPPORT_TIER',
  TranscendHostedPromptManagerMonthlyUsageLimit = 'TRANSCEND_HOSTED_PROMPT_MANAGER_MONTHLY_USAGE_LIMIT',
  UnstructuredDataDiscovery = 'UNSTRUCTURED_DATA_DISCOVERY',
  WebConsent = 'WEB_CONSENT',
  WhiteLabelPrivacyCenter = 'WHITE_LABEL_PRIVACY_CENTER',
  WhiteLabelPrivacyRequestEmails = 'WHITE_LABEL_PRIVACY_REQUEST_EMAILS',
  WorkflowsV2 = 'WORKFLOWS_V2',
}
